import React from "react";
import "./ServicesDetails.css";

const ServicesDetails = ({servicesData}) => {
  return (
    <section className="section services-section">
      <div className="services-wrapper">
        {servicesData.map((service, index) => (
          <div key={index} className="services-container-wrapper">
            <div className="services-card container">
              <div className="services-title-area">
                <div className="title-heading-div">
                  <h2 className="title">
                    <span>
                      {service.title1}
                      <br />
                      {service.title2}
                    </span>
                  </h2>
                </div>
                <div className="text-muted">
                  <p>{service.tagline}</p>
                </div>
              </div>
              <div className="blank-area"></div>
              <div className="services-paragraph-details">
                <p className="large-text-paragraph">
                  {service.shortDescription}
                </p>
                <p className="normal-text-paragraph">
                  {service.longDescription}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesDetails;
